import { LoanNoteReason as GqlLoanNoteReason } from '@willow/graphql-iso/src/app';
import { LoanNoteReason } from '@willow/types-iso';

import { convertGqlEnumToEnum } from './convertEnumToGqlEnum';

export const gqlToIsoLoanNoteReason = convertGqlEnumToEnum<typeof GqlLoanNoteReason, LoanNoteReason>(GqlLoanNoteReason);
